<wr-base-dialog status="info" header="Alter Rundgang gefunden!" submitText="Ja" cancelText="Nein">
  <div class="content">Willst du die Prüfpunkte des letzten Rundgangs übernehmen?</div>
  <nb-alert outline="basic" *ngIf="inspection">
    <b>Rundgang #{{inspection.continuationNumber}}
      vom {{inspection.fromTimestamp | date: 'dd.MM.yyyy'}}</b>
    <div>{{inspection.building.baseData.sectionText}}</div>
  </nb-alert>
</wr-base-dialog>
